import React, { useCallback } from 'react';
import { Box, Typography, Tooltip, TypographyProps } from '@mui/material';
import DateText from '@ui/DateText';
import { useCommentsStore } from '@client/store/comment/comment.store';
import { IComment } from '@shared/models/comment.model';
import { IconButton } from '@ui/buttons';
import { mergeSx } from '@client/helpers/mui.helpers';

interface CommentsIconButtonProps {
  comments: IComment[];
}

const tooltipContentSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 1,
} as const;

const commentCountSx = { fontWeight: 500 } as const;

const CommentsIconButton: React.FC<CommentsIconButtonProps> = ({
  comments,
}) => {
  const setScrollCommentsIntoView = useCommentsStore(
    ({ setScrollCommentsIntoView }) => setScrollCommentsIntoView,
  );
  const firstComment = comments[0];

  const handleIconClick = useCallback(() => {
    setScrollCommentsIntoView(true);
  }, [setScrollCommentsIntoView]);

  return (
    <Tooltip
      title={
        <Box sx={tooltipContentSx}>
          <Typography
            {...textStyles}
            sx={mergeSx(commentCountSx, textStyles.sx)}
          >
            {comments.length} {comments.length > 1 ? 'comments' : 'comment'}
          </Typography>

          <DateText
            date={firstComment?.created_at}
            format={{ type: 'RELATIVE' }}
            variant="caption"
            color={textStyles.color}
            sx={textStyles.sx}
          />
        </Box>
      }
    >
      <span>
        <IconButton
          category="mui"
          icon="Comment"
          size={12}
          onClick={handleIconClick}
        />
      </span>
    </Tooltip>
  );
};

const textStyles: TypographyProps = {
  color: '#fff',
  sx: { fontSize: 10 },
} as const;

export default CommentsIconButton;
